export default __webpack_public_path__ + "static/media/Broadcast.eb828aea.svg";